module.exports = __webpack_public_path__ + "static/img/toujiao3.5fc5f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao3.jpg
// module id = h4RY
// module chunks = 1